/**
 * Console twin of the product's `#/shared/lib/ability` surface.
 *
 * The product derives abilities from the tenant token's role permissions;
 * the console authenticates a platform admin, who operates on every tenant
 * with full rights. `can` is therefore always true and no grant is ever
 * `own`-scoped — the vendored eligibility hooks (`useCanBackToQuote`, …)
 * then take their product code path for a fully-privileged operator.
 */

export type Action = string
export type Resource = string
export type Scope = 'all' | 'team' | 'own'

export interface Ability {
  can: (action: Action, resource: Resource) => boolean
}

const PLATFORM_ADMIN: Ability = { can: () => true }

export function useAbility(): Ability {
  return PLATFORM_ADMIN
}

export function useScopeOf(): (resource: Resource, action: Action) => Scope | null {
  return () => 'all'
}
